module.exports = __webpack_public_path__ + "static/img/hynds-vip.d99b36f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hynds-vip.svg
// module id = Ss4R
// module chunks = 1